import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PHBHPFeaturePackageConfigurationService } from '../ph-bhp-feature-package-configuration.service';
import { Country } from '../Models/Country';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { AppConfig } from 'src/app/app.config';
//import { TranslateService } from '@ngx-translate/core';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'app-ph-bhp-configure-country',
  templateUrl: './ph-bhp-configure-country.component.html',
  styleUrls: ['./ph-bhp-configure-country.component.css']
})
export class PhBhpConfigureCountryComponent implements OnInit {

  gridData: any;
  countriesKeyValue: any;
  fields: any[];
  pageInfo: any;
  modalRef: BsModalRef;
  searchText: string = '';
  countriesList;
  @ViewChild('grid') grid: any;
  @ViewChild('delmodal') delmodal: TemplateRef<any>;
  deleteDataItem
  deleterowIndex

  countryModelGridEdit: any = new UntypedFormGroup({
    countryID: new UntypedFormControl('', Validators.compose([Validators.required])),
    name: new UntypedFormControl('', Validators.compose([Validators.required, Validators.maxLength(40)])),
    username: new UntypedFormControl('', Validators.compose([Validators.required, Validators.maxLength(25)])),
    email: new UntypedFormControl('', Validators.compose([Validators.required, Validators.maxLength(100), Validators.pattern('^[A-Za-z0-9._%+-]+@[a-z0-9.-]+(\\.[a-z]{2,4})+$')]))

  });
  translationKeys: typeof TranslationKeys = TranslationKeys;

  actionItems: any = [
    { name: 'CONFIGURE.EDIT', imgSrc: 'assets/ph-bhp-layout/svg/icon-edit.svg', isEdit: true },
    { name: 'LAYOUT_MODULE.DELETE', imgSrc: 'assets/ph-bhp-layout/svg/icon-delete.svg', onClick: (dataItem) => { this.openDeleteModal(this.delmodal, dataItem);} },
  ];


  constructor(
    private service: PHBHPFeaturePackageConfigurationService,
    public config: AppConfig,
    private layoutService: PHBHPLayoutPackageService,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.fields = [
      {
        'field': 'countryName', 'title': 'CONFIGURE.COUNTRY',
        editTemplate: {
          type: 'dropdown',
          textField: 'countryName',
          valueField: 'countryID',
          validator: (dataItem) => {
            if (dataItem.countryName != null && dataItem.countryName != '') {
              return true;
            }
            this.layoutService.showError(this.layoutService.translateText('ERROR_MESSAGES.REQUIRED.COUNTRY'));
            return false;
          }
        }
      },
      {
        'field': 'name', 'title': 'CONFIGURE.NAME',
        editTemplate: {
          type: 'text',
          maxLength: 40,
          validator: (dataItem) => {
            if (dataItem.name != null && dataItem.name != '') {
              return true;
            }
            this.layoutService.showError(this.layoutService.translateText('ERROR_MESSAGES.REQUIRED.NAME'));
            return false;
          }
        }
      },
      {
        'field': 'username', 'title': 'CONFIGURE.USERNAME',
        editTemplate: {
          type: 'text',
          maxLength: 25,
          validator: (dataItem) => {
            if (dataItem.username != null && dataItem.username != '') {
              return true;
            }
            this.layoutService.showError(this.layoutService.translateText('ERROR_MESSAGES.REQUIRED.USERNAME_OR_MAIL'));
            return false;
          }
        }
        //"editable": false
      },
      {
        'field': 'email', 'title': 'CONFIGURE.E_MAIL',
        editTemplate: {
          type: 'text',
          maxLength: 100,
          validator: (dataItem) => {
            if (dataItem.email != null && dataItem.email != '') {
              return true;
            }
            this.layoutService.showError(this.layoutService.translateText('ERROR_MESSAGES.REQUIRED.USERNAME_OR_MAIL'));
            return false;
          }
        }
        //"editable": false
      }
    ];

    this.pageInfo = {
      items: 'CONFIGURE.COUNTRY_ADMINS',
      itemsPerPageLabel: 'CONFIGURE.PER_PAGE.COUNTRY_ADMINS'
    };


    this.getCountryList();
    this.service.getCountriesKeyValuePair().subscribe((res: any) => {
      this.countriesKeyValue = res;
    });
    this.getCountryListOnLoad();

    this.layoutService.lang.subscribe(() => {
      this.getCountryListOnLoad();
      this.getCountryList();
      // this.countrydropdowntranslate(this.countriesList);
    });
  }

  getCountryListOnLoad() {
    this.service.getCountryList().subscribe((res) => {
      this.countriesList = res;
      // this.fields[0].ngTemplate = (dataItem) => {
      //   dataItem.countryID = dataItem.countryId;
      //   const country = this.countriesList.find(x => x.countryID === dataItem.countryID);
      //   return (country) ? this.layoutService.translateText(country.countryName) : '';
      // };
      this.countrydropdowntranslate(this.countriesList);
      // this.fields[0].ngEditTemplate.data = res;
    });
  }

  getCountryList() {
    this.layoutService.showLoader = true;
    this.service.getCountry(2).subscribe((res: any) => {
      this.layoutService.showLoader = false;
      this.gridData = res;
    });
  }

  countrydropdowntranslate(res) {
    const contries = JSON.stringify(res);
    const contriesList = JSON.parse(contries);
    contriesList.forEach((element, index) => {
      element.countryName = this.layoutService.translateText(element.countryName);
    });
    this.fields[0].editTemplate.data = contriesList;
  }

  randomPassword(length) {
    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var newpassword = "";
    for (var x = 0; x < length; x++) {
      var i = Math.floor(Math.random() * chars.length);
      newpassword += chars.charAt(i);
    }
    return newpassword;
  }

  handlerData({ handler, formGroup, isNew, dataItem, rowIndex }): void {
    switch (handler) {

      case 'saveHandler':
        var countryData = dataItem;
        countryData.password = "";
        countryData.roleId = 2;
        countryData.isActive = true;
        if (isNew) {
          let newData = {
            "user": countryData,
            "institutions": "",
            "webUrl": this.config.siteUrl,
            "languageCode": localStorage.getItem("selectedlanguage")
          }
          newData.user.username = newData.user.username.split(' ').join('');
          let data = {
            personalInformation: newData,
            platformUserPersonalInformation: null
          }
          this.layoutService.showLoader = true;
          this.service.createCountry(data).subscribe((res: Country) => {
            this.layoutService.showLoader = false;
            this.layoutService.showSuccess(this.layoutService.translateText('USER_MANAGEMENT.SUCCESSFULLY_ADDED_COUNTRY_ADMIN'));
            this.getCountryList();
          });

        } else if (!isNew) {

          let data = {
            userId: dataItem.userId,
            countryId: countryData.countryID,
            name: countryData.name,
            roleId: 2,
            email: countryData.email,
            isActive: true
          }
          let newData = {
            "user": data
          }
          this.service.updateCountry(dataItem.userId, newData).subscribe((res: Country) => {
            this.gridData[rowIndex].countryId = countryData.countryID
            this.gridData[rowIndex].name = countryData.name;
            this.gridData[rowIndex].email = countryData.email;
            this.layoutService.showSuccess(this.layoutService.translateText('CONFIGURE.MESSAGE_SUCCESSFULLY.UPDATED.COUNTRY_ADMIN'));
            this.getCountryList();
          })
        }
        break;
      case 'removeHandler':
        // this.openDeleteModal(this.delmodal, dataItem, rowIndex);
        break;
    }
  }

  openDeleteModal(deletemodal: TemplateRef<any>, dataItem) {
    this.deleteDataItem = dataItem;
    this.modalRef = this.modalService.show(deletemodal, Object.assign({}, { class: 'w-420' })
    );
  }

  delete() {
    this.service.deleteCountry(this.deleteDataItem.userId).subscribe((res: Country) => {
      this.getCountryList();
    });
  }

  addRow() {
    this.grid.addRow();
  }

  onSearchTextChanged(text: string): void {
    this.searchText = text;
  }
}
